import getFullSearchHistoryFromRestOperation from 'owa-service/lib/operation/getFullSearchHistoryFromRestOperation';
import { orchestrator, action } from 'satcheljs';
import { getUserConfiguration } from 'owa-session-store';
var exportSearchHistory = action('exportSearchHistory', function () {
    return { userConfig: getUserConfiguration() };
});
orchestrator(exportSearchHistory, function (actionMessage) {
    // Get the REST search history, merge it with the client search
    // history, and export the merged histories
    getFullSearchHistoryFromRestOperation({}).then(function (result) {
        var suggestions = result.Response ? result.Response.value : [];
        var suggestionTexts = suggestions.map(function (e) { return e.SuggestedQuery; });
        var blob = new Blob([
            suggestionTexts.join('\n'),
            actionMessage.userConfig.ViewStateConfiguration.SearchHistory.join('\n'),
        ], { type: 'text/plain' });
        var FileSaver = require('file-saver');
        FileSaver.saveAs(blob, 'search_history.csv');
    });
});
export default exportSearchHistory;
//# sourceMappingURL=exportSearchHistory.js.map